import axios from 'axios';

import { config } from './environment';

export const axiosClient = axios.create({
  baseURL: config.BACKEND_URL,
  timeout: 5000,
});
